import dayjs from "dayjs"
import { Typography } from "@mui/material"
import { jobOrderColNm } from "constants/jobOrderConstant"
import { shipmentColNm } from "constants/shipmentConstant"

// JobOrdId and ContNo are the cells the user clicks to pick a job order
const renderClickableCell = ({ value }) => value ? (
  <Typography
    variant="body2"
    sx={{ cursor: "pointer", color: "primary.main", textDecoration: "underline" }}
  >
    {value}
  </Typography>
) : "-"

export const selectJobOrderColumns = [
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: "center",
  },
  {
    field: "JobOrdId",
    headerName: jobOrderColNm.JobOrdId,
    width: 90,
    renderCell: renderClickableCell,
  },
  {
    field: "ContNo",
    headerName: jobOrderColNm.ContNo,
    width: 120,
    renderCell: renderClickableCell,
  },
  {
    field: "AptTm",
    headerName: jobOrderColNm.AptTm,
    width: 110,
    valueFormatter: ({ value }) => value ? dayjs(value).format("DD/MM/YY HH:mm") : "-",
  },
  {
    field: "CusSNm",
    headerName: shipmentColNm.CusSNm,
    width: 130,
  },
  {
    field: "JobSNm",
    headerName: shipmentColNm.JobSNm,
    width: 130,
  },
  {
    field: "JobNo",
    headerName: jobOrderColNm.JobNo,
    width: 120,
  },
  {
    field: "Bkg",
    headerName: jobOrderColNm.Bkg,
    width: 120,
  },
  {
    field: "TakePlc",
    headerName: jobOrderColNm.TakePlc,
    width: 110,
  },
  {
    field: "Loc",
    headerName: jobOrderColNm.Loc,
    width: 110,
  },
  {
    field: "RtnPlc",
    headerName: jobOrderColNm.RtnPlc,
    width: 110,
  },
]
